<template>
  <b-table-lite
    striped
    responsive
    borderless
    hover
    tbody-tr-class="table-row"
    :items="ranks"
    :fields="fields"
    @row-clicked="onRowClicked"
  >
  </b-table-lite>
</template>

<script>
import { BTableLite } from "bootstrap-vue";
import utils from "../utils";

export default {
  name: "PlayerRanks",
  props: [ "ranks" ],
  components: { BTableLite },
  data() {
    return {
      fields: [
        { key: "quest.title" },
        { key: "quest.type" },
        { key: "score", label: "Score", formatter: (v, k, i) => utils.formatScore(v, i.quest.type) },
        { key: "starRating", label: "Jax" },
      ],
    };
  },
  methods: {
    onRowClicked(item, index) {
      console.log(`Item: ${JSON.stringify(item)}. Index: ${index}. PID: ${item.id}.`);
      this.$router.push({ name: "quest", params: { id: item.quest.id } });
    },
  }
};
</script>

<style>
</style>